import React from 'react';

import { errorMessages } from 'src/translates/errorMessages';

import { DefaultErrorOverlay } from '@ael/shared-components-library/student-shell';
import { useIntl } from 'react-intl';

export const ProjectNotAvailableErrorOverlay = () => {
  const intl = useIntl();

  return (
    <DefaultErrorOverlay
      title={intl.formatMessage(errorMessages.courseUnavailableTitle)}
      description={<p>{intl.formatMessage(errorMessages.courseUnavailableDescription)}</p>}
    />
  );
};
